import React, { useEffect, useState } from 'react';
import './SiteDatabase.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Space, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../Config';
import axios from 'axios';

const SiteDatabase = () => {
  const navigate = useNavigate();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [tasks, setTasks] = useState([]);

    useEffect(() => {
      let endpoint = API_URL + '/client'

      fetch(endpoint)
        .then((response) => response.json())
        .then((data) => setTasks(data))
        .catch((error) => console.error(error));
    }, []);

  const fetchTasks = (filterValue) => {
    let endpoint;

     if (filterValue) {
      endpoint = `${API_URL}/client/?filter=${filterValue}`;
    }
     else {
      endpoint = `${API_URL}/client`;
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setTasks(data))
      .catch((error) => console.error(error));
  };

  const getSiteDetails = (siteName) => {
    const filteredSite = tasks.filter(task => task.siteName === siteName);
    navigate('/SiteDetails', { state: { siteDetails: filteredSite[0] } });
  };

  const getSiteName = (siteName) => {
    navigate('/AgencyDatabase', { state: { siteName: siteName } });
  }

  const deleteSite = async (name) => {
    try {
      const response = await axios.delete(API_URL + `/client/${name}`);

      if (response.status === 204) {
        console.log('Site deleted successfully');
        fetchTasks();
      } else {
        console.error('Error deleting User');
      }
    } catch (error) {
      console.error(error);
    }
  };

  // =========== add site start ================================================
  const [formData, setFormData] = useState({
    clientName:  '',
    siteName:  '',
    siteAddress:  '',
    siteMobile: '',
    siteEmail: '',
    manager: '',
    work_type: '',
    reference_name: '',
    date_of_birth:  '',
    contractNo: '',
    registration_date:  '',
    interior_designer:  '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [clients, setClients] = useState([]);
  useEffect(() => {
    fetch(API_URL + '/client')
      .then(response => response.json())
      .then(data => setClients(data))
      .catch(error => console.error(error));
  }, []);

  let work_type_data;
  let manager_data;
  if(clients && clients.length > 0) {
     work_type_data = clients.map(user => user.work_type).filter((value, index, self) => self.indexOf(value) === index);
     manager_data = clients.map(user => user.manager).filter((value, index, self) => self.indexOf(value) === index);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch(API_URL + '/client', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Form data sent successfully:', data);
        closeForm();
        fetchTasks();
      })
      .catch((error) => {
        console.error('Error sending form data:', error);
      });
  };

  // =========== end ===========================================================


  const openForm = () => {
    setIsFormOpen(true);
  };

  const closeForm = () => {
    setIsFormOpen(false);
  };

    const columns = [
      {
        title: 'Index',
        dataIndex: 'Index',
        key: 'Index',
        width: '10%',
      },
      {
        title: 'Site Name',
        dataIndex: 'SiteName',
        key: 'SiteName',
      },
      {
        title: 'View Agencies',
        dataIndex: 'ViewAgencies',
        key: 'ViewAgencies',
        render: (_, record ) => (
          <button className='view_agency_SiteDatabase' onClick={() => getSiteName(record.SiteName)}>
           View Agencies
          </button>
          // <Link to={{ pathname: '/AgencyDatabase', state: { siteName: record.SiteName } }}><p>&nbsp;View Agencies</p></Link>
        ),
      },
      {
        title: 'Action',
        key: 'action',
        width: '12%',
        render: (_, record) => (
          <Space size="middle">
            <div onClick={() => getSiteDetails(record.SiteName)}>
            <img className='search' src="../assets/pencil.png" alt="search" height={"24px"}></img>
          </div>
          <div onClick={() => deleteSite(record.SiteName)}>
            <img className='search' src="../assets/trash.png" alt="search" height={"23px"}></img>
          </div>
          </Space>
        ),
      },
    ];

    const dataa = tasks.length > 0 ? tasks.map((item, index) => ({
      key: index.toString(),
      Index: index + 1,
      SiteName: item.siteName || '',
    })) : [];


return( 
<div>
    <SideMenuBar></SideMenuBar>
        
    <div class="content">
        <NewHeader></NewHeader>
        
          <div className='row2'>
            <h3 className='directory_Directory'>Directory</h3>  
          </div>
        
          <div className='row3'>
            <div className='searchBox'>
              <div class="column1_searchBox">
                <img className='search' src="../assets/search.png" alt="search" height={"18px"}></img>
              </div>
  
              <div class="column2_searchBox">
                <input className='search_input1' placeholder='Search' onChange={(e) => {
              const text = e.target.value;
              fetchTasks(text);
            }}></input>
              </div>
            </div>
            <button onClick={openForm} className='add_site_btn_SiteDatabase'> + Add Site</button>
          </div>
      {isFormOpen && (
        <>
          <div className="overlay_SiteDatabase" onClick={closeForm}></div>
          <div className="popup-form_SiteDatabase">
            <span className="close_SiteDatabase" onClick={closeForm}>&times;</span>
            <p className='addSite_popup_SiteDatabase'><b>Add Site</b></p>
            {/* Your form content goes here */}
            <form>

          <div class="row5_SiteDatabase">
            <div class="row5_column1_SiteDatabase">
              <p>Client Name</p>
                <input className='input_popup_SiteDatabase' placeholder='Enter Client Name' name='clientName'
                      value={formData.clientName}
                      onChange={handleInputChange}></input>

              <p>Site Name</p>
                <input className='input_popup_SiteDatabase' placeholder='Enter Site Name' name='siteName'
                      value={formData.siteName}
                      onChange={handleInputChange}></input>

              <p>Phone No.</p>
                <input className='input_popup_SiteDatabase' placeholder='Enter Phone No.' name='siteMobile'
                      value={formData.siteMobile}
                      onChange={handleInputChange}></input>
              
              <p>Email ID</p>
                <input className='input_popup_SiteDatabase' placeholder='Enter Email ID' name='siteEmail'
                      value={formData.siteEmail}
                      onChange={handleInputChange}></input>

              <p>Date of Birth</p>
                <input type="date" id="date"  className='popup_form_DOB' name='date_of_birth'
                      value={formData.date_of_birth}
                      onChange={handleInputChange}/> 

              <p>Registration Date</p>
                <input type="date" id="date" className='popup_form_regDate' name='registration_date'
                      value={formData.registration_date}
                      onChange={handleInputChange}/> 

            </div>
  
            <div class="row5_column2_SiteDatabase">
              <p>Work Type</p>
                <select className='popup_form_select'  name='work_type'
              value={formData.work_type}
              onChange={handleInputChange}>
                  <option value=""  disabled hidden>Select</option> 
                  {work_type_data.map((workType, index) => (
                <option key={index} value={workType} className='options'>
                  {workType}
                </option>
              ))}
                </select>

              <p>Manager</p>
                <select className='popup_form_select' name='manager'
              value={formData.manager}
              onChange={handleInputChange}>
                  <option value=""  disabled hidden>Select</option> 
                  {manager_data.map((manager, index) => (
                <option key={index} value={manager} className='options'>
                  {manager}
                </option>
              ))}
                </select>

              <p>Contract No.</p>
                <input className='input_popup_SiteDatabase' placeholder='Enter Contract No.' name='contractNo'
                      value={formData.contractNo}
                      onChange={handleInputChange}></input>

              <p>Referral Name</p>
                <input className='input_popup_SiteDatabase' placeholder='Enter Referral Name' name='reference_name'
                      value={formData.reference_name}
                      onChange={handleInputChange}></input>

              <p>Interior Designer</p>
                <input className='input_popup_SiteDatabase' placeholder='Enter Interior Designer' name='interior_designer'
                      value={formData.interior_designer}
                      onChange={handleInputChange}></input>

              <p>Address</p>
                <textarea className='address_input_SiteDatabase' placeholder='Enter Address' name='siteAddress'
                      value={formData.siteAddress}
                      onChange={handleInputChange}></textarea><br/>

              <button className='update_btn_input_SiteDatabase' onClick={handleSubmit}>Add</button>
            </div>
          </div>     
            </form>
          </div>
        </>
      )}

          <div className='row6_SiteDatabase'>
              <p>Site Database</p>
          </div>

          <div className='table_SiteDatabase'>
            <Table 
              columns={columns} 
              dataSource={dataa} 
              scroll={{ y: 420 }}
              pagination={false}
            />
          </div>


    <br/><br/>
    </div>
</div>
 )
}

export default SiteDatabase;